<script setup lang="ts">
import { PrimaryButton } from '@hfc/ui-core';
import { CarrierPageData } from '@/page/domain/CarrierPageData';
import TextAndImage from '@/page/infrastructure/components/TextAndImage.vue';
import { useUrlHelper } from '@/page/infrastructure/composition/useUrlHelper';

const { getIaFQuoteUrl } = useUrlHelper();

withDefaults(defineProps<{
  carrierId: string;
  redirectButtonText?: string;
  carrierData: Partial<CarrierPageData>;
}>(), {
  redirectButtonText: 'GET MY FREE QUOTE NOW!'
});
</script>

<template>
  <TextAndImage content-direction="right" div-class="px-6">
    <template #text>
      <div class="flex flex-col h-full items-center justify-center text-center space-y-6 mt-10 lg:mt-0">
        <h1 v-html="carrierData.title"></h1>
        <h2 class="font-light" v-html="carrierData.content"></h2>
        <PrimaryButton class="text-sm lg:text-md uppercase" size="lg" :href="carrierData.redirectUrl ? carrierData.redirectUrl : getIaFQuoteUrl()">
          {{ redirectButtonText }}
        </PrimaryButton>
      </div>
    </template>
    <template #image>
      <div class="flex flex-1 justify-center items-center">
        <div class="w-56 lg:w-72">
          <carrier-logo :carrier-id="carrierId" vertical="true" no-link="true" custom-class="w-full" />
        </div>
      </div>
    </template>
  </TextAndImage>
</template>
